/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 06/04/2022.
 */

import { Select } from 'antd'
import { useEffect, useState } from 'react'
import { FormLabel } from './FormLabel'
import { UseFormReturn } from 'react-hook-form'
import { DropdownFormConfigObject } from '../../Types'

type Props = { formHook: UseFormReturn; data: DropdownFormConfigObject }

export const FormDropDown = ({ data, formHook }: Props) => {
  const {
    setValue,
    register,
    unregister,
    formState: { errors },
    getValues,
  } = formHook

  // Handle nested IDs
  const arr = data.id.split('.')
  const errorState = arr.reduce((accum: any, prop: string) => accum && accum[prop], errors)

  const formValue = getValues(data.id)
  const currentValue = !formValue ? data.value : formValue

  const [state, setState] = useState<string | null>(currentValue)

  useEffect(() => {
    register(data.id, { ...data.validation, value: data.value || null })
  }, [register, unregister, data.id, data.validation, data.value])

  //
  // this might look duplicated code, but if we place register and unregister in the useEffect,
  // we get the exceed the maximum update depth error
  //
  useEffect(() => {
    return () => {
      unregister(data.id)
    }
  }, [unregister, data.id])

  const handleChange = (value) => {
    setValue(data.id, value)
    setState(value)
  }

  return (
    <div className={` ${data.className} py-2`}>
      <FormLabel label={data.label} />
      <Select
        //defaultValue={state}
        value={state}
        style={{ width: '100%' }}
        onChange={handleChange}
        placeholder={data.placeholder}
        options={data.options}
        status={errorState ? 'error' : ''}
        disabled={data.disabled}
      >
        {/*{items}*/}
      </Select>

      {errorState ? <div className="p-small text-danger">{data.errorMsg}</div> : null}
    </div>
  )
}
